import { formatNumber } from '../../utils/intl';
import translate from '../../utils/webcomponents/translate';
import { payoffTypes } from './turbomap-utils';

import { LitElement, html } from 'lit-element';

const PLACEHOLDER_EMPTY_VALUE = '–';

const formatNumberOrDefault = (value, defaultValue = PLACEHOLDER_EMPTY_VALUE) => (value
	? formatNumber(value)
	: defaultValue);

const valueOrDefault = (value = PLACEHOLDER_EMPTY_VALUE) => value;

const renderTurboSpecificDetails = details => html`
	<div class="turbomap-details__item">
		<div class="turbomap-details__label">${translate('turbomap', 'excercisePrice', 'Excercise price')}:</div>
		<div class="turbomap-details__value">${formatNumberOrDefault(details.excercisePrice)}</div>
	</div>

	<div class="turbomap-details__item">
		<div class="turbomap-details__label">${translate('turbomap', 'barrier', 'Barrier level')}:</div>
		<div class="turbomap-details__value">${formatNumberOrDefault(details.barrierLevel)}</div>
	</div>
`;

const renderWarrantSpecificDetails = details => html`
	<div class="turbomap-details__item">
		<div class="turbomap-details__label">${translate('turbomap', 'delta', 'Delta')}:</div>
		<div class="turbomap-details__value">${formatNumberOrDefault(details.delta)}</div>
	</div>

	<div class="turbomap-details__item">
		<div class="turbomap-details__label">${translate('turbomap', 'strikePrice', 'Strike')}:</div>
		<div class="turbomap-details__value">${formatNumberOrDefault(details.strikePrice)}</div>
	</div>
`;

const renderPayoffSpecificDetails = details => (details.payoffType === payoffTypes.TURBO
	? renderTurboSpecificDetails(details)
	: renderWarrantSpecificDetails(details));

const renderDetails = details => html`
		<div class="turbomap-details">
			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${details.identifierLabel}</div>
				<div class="turbomap-details__value">${details.identifier}</div>
			</div>

			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${translate('turbomap', 'productType', 'Product type')}:</div>
				<div class="turbomap-details__value">${valueOrDefault(details.productType)}</div>
			</div>

			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${translate('turbomap', 'maturityDate', 'Maturity date')}:</div>
				<div class="turbomap-details__value">${valueOrDefault(details.maturityDate)}</div>
			</div>

			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${translate('turbomap', 'leverage', 'Leverage')}:</div>
				<div class="turbomap-details__value">${formatNumberOrDefault(details.leverage)}</div>
			</div>

			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${translate('turbomap', 'bid', 'Bid')}:</div>
				<div class="turbomap-details__value">${formatNumberOrDefault(details.bid)}</div>
			</div>

			<div class="turbomap-details__item">
				<div class="turbomap-details__label">${translate('turbomap', 'ask', 'Ask')}:</div>
				<div class="turbomap-details__value">${formatNumberOrDefault(details.ask)}</div>
			</div>

			${renderPayoffSpecificDetails(details)}
		</div>
	`;
const renderFooter = ({ url }) => html`
	<div class="text-center">
		<a href="${url}" class="button">${translate('turbomap', 'details', 'Details')}</a>
		<button class="button button--ghost js-close">${translate('turbomap', 'close', 'Close')}</button>
	</div>
`;

class TurbomapProductDetail extends LitElement {
	static get properties() {
		return {
			details: {
				type: Object,
			},
		};
	}

	render() {
		return html`
			${renderDetails(this.details)}
			${renderFooter(this.details)}
		`;
	}

	createRenderRoot() {
		return this;
	}
}

customElements.define('x-turbomap-product-detail', TurbomapProductDetail);

export default TurbomapProductDetail;
